import { AlignmentType, Paragraph, BorderStyle, TextRun, TableRow, TableCell, Table, WidthType, ShadingType } from "docx"

export const SeverityDetermination = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 500, after: 200 },
    children: [
        new TextRun({
            text: "Severity Determination",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})



export const SeverityDeterminationText = new Paragraph({
    alignment: AlignmentType.JUSTIFIED,
    // spacing: { before: 100, after: 200 },
    spacing: { line: 376 },
    children: [
        new TextRun({
            text: "This section provides the indication of the severity of vulnerabilities identified, and the priority with which the same needs to be addressed by business units. The severity rating represented below is Base Score which represents only the intrinsic characteristics of a vulnerability that are constant over time and across user environments.",
            size: 24,
            color: "000000",
            font: "Arial",
            bold: false,
            italics: false
        })
    ],
})

export const RiskRating = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 500, after: 200 },
    children: [
        new TextRun({
            text: "Risk Rating based on Severity:",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const riskRatingTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Rating",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "D9E2F3",
                    },

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "D9E2F3",
                    },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },

                }),
            ]
        }),



        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "H (High)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })]
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Serious impact to the application security, generally unmitigated, large-scale issues, such as an attack that is currently exploitable from the Internet.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),

                            ]
                        }),

                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "M (Medium)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Notable impact to the application security, or somewhat mitigated high risks (e.g., being available only to the user's Intranet)",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),
                            ]
                        }),

                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "L (Low)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Potential impact to the application security, or heavily mitigated high risk (e.g., being in dead code or after an abort call).",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),
                            ]
                        }),
                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),


    ]
})